<template>
  <div class="container pos-rel">
    <div class="pos-rel">
      <img src="/static/images/bg-download.png" style="width: 100%" />
    </div>
    <div class="pos-abs f-view-r-c-c fixed-download">
      <div
        type="button"
        class="btn btn-downlaod small"
        onClick="download('iphone')"
        >iphone下载</div>
      <div
        type="button"
        class="btn btn-downlaod margin-l-20"
        onClick="download('android')"
        >安卓下载</div
      >
      <div class="margin-l-20">
        <img src="/static/images/qr_code.png" style="width: 40px" />
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "download",
  components: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
  
<style scoped>
</style>
  


// WEBPACK FOOTER //
// src/page/homepage/components/sm/download.vue